import React from 'react';
import styles from './index.css';


const Bubble = (props) => {
        return(
            <div className={styles.bubbling + ' ' + styles[props.culture]}>
                <span/>
                <span/>
            </div>
        )
}
export default Bubble;



// WEBPACK FOOTER //
// ./src/shared/components/Game/SubComponents/Bubbles/index.js